import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useId } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/Select';
import { handwritingStyleFontMap } from '../../../components/settings/PersonalSettings/HandwrittenCardSettings';
import { TextInput } from '../../../components/TextInput';
import { bs } from '../../../styles/styles';

interface Props {
	handwritingStyle: Api.HandwritingStyle;
	onChangeHandWritingStyle: (handwritingStyle: Api.HandwritingStyle) => void;
	disabled?: boolean;
}

export function HwcSettingsWritingStyleInputWithPreview({
	handwritingStyle,
	onChangeHandWritingStyle,
	disabled,
}: Props) {
	const id = useId();
	return (
		<>
			<div className={css(bs.flex, bs.itemsStart)}>
				<label className={css(bs.textHeader, bs.inlineBlock, bs.textSm, bs.w48)}>Writing Style</label>
				<div>
					<Select value={handwritingStyle} onValueChange={onChangeHandWritingStyle} disabled={disabled}>
						<SelectTrigger styles={[bs.w80]}>
							<SelectValue />
						</SelectTrigger>
						<SelectContent>
							{Api.SupportedHandwritingStyles.map(hwStyle => (
								<SelectItem key={`${id}-${hwStyle}`} value={hwStyle}>
									{hwStyle}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</div>
			</div>
			<div className={css(bs.flex, bs.itemsStart)}>
				<TextInput
					style={{
						fontFamily: handwritingStyleFontMap[handwritingStyle].fontFamily,
						fontSize: `${handwritingStyleFontMap[handwritingStyle].fontSize}px`,
					}}
					inputClassName={css(bs.textBase)}
					className={css(bs.w96, bs.ml48)}
					disabled={true}
					type='text'
					inputId='hwc-style-example'
					value='The quick brown fox jumped over the lazy dog'
				/>
			</div>
		</>
	);
}
